import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter, Route, Routes, useNavigate, useParams} from "react-router-dom";
import {Button, Form, InputNumber, Layout, Menu} from "antd";

const {Header} = Layout;


function WrapEditorPage() {
    const {siteID} = useParams()
    return <App location={window.location} siteID={Number.parseInt(siteID!)}/>
}


function IndexPage() {
    const [form] = Form.useForm<{ name: string; age: number }>();
    let navigate = useNavigate();

    return <>
        <Form form={form} layout="vertical" autoComplete="off" style={{width: "500px", margin: "10px"}} onFinish={(data: any) => {
            navigate(`/edit/${data.id}`);
        }}>
            <Form.Item initialValue={90001} name="id" label="Введите ID сайта">
                <InputNumber style={{width: "100%"}}/>
            </Form.Item>
            <Form.Item>
                <Button type={"primary"} htmlType={"submit"}>Перейти</Button>
            </Form.Item>
        </Form>
    </>
}

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            <Layout>
                <Header className="header">
                    <div className="logo"/>
                    <Menu theme="dark" mode="horizontal" defaultSelectedKeys={['1']}>
                        <Menu.SubMenu key={"1"} title={"Отзовики"}>
                            <Menu.Item key="2">Поиск Ссылок на фирмы</Menu.Item>
                            <Menu.Item key="3">Парсер инфы о фирме</Menu.Item>
                            <Menu.Item key="4">Парсер отзывов со страницы фирмы</Menu.Item>
                        </Menu.SubMenu>
                    </Menu>
                </Header>

                <Routes>
                    <Route index element={<IndexPage/>}/>
                    <Route path={"/edit/:siteID"} element={<WrapEditorPage/>}/>
                </Routes>
            </Layout>
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
